import React from "react";
import { Pressable, Text, View } from "react-native";

import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

export default function AttractScreen({ navigate, copy }) {
  return (
    <View
      style={{
        flex: 1,
        minHeight: "100vh",
        padding: 32,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          color: C.muted,
          fontSize: 14,
          fontWeight: "900",
          letterSpacing: 1.4,
          textAlign: "center",
        }}
      >
        {copy.attract.eyebrow}
      </Text>

      <View
        style={{
          width: 210,
          height: 210,
          marginTop: 34,
          marginBottom: 34,
          borderRadius: 999,
          borderWidth: 2,
          borderColor: C.accent,
          backgroundColor: C.accentSoft,
          alignItems: "center",
          justifyContent: "center",
          shadowColor: C.accent,
          shadowOpacity: 0.2,
          shadowRadius: 30,
        }}
      >
        <Text style={{ color: C.text, fontSize: 58, fontWeight: "900" }}>AI</Text>
      </View>

      <Text
        style={{
          color: C.text,
          fontSize: 54,
          lineHeight: 60,
          fontWeight: "900",
          textAlign: "center",
          maxWidth: 900,
        }}
      >
        {copy.attract.title}
      </Text>

      <Text
        style={{
          color: C.muted,
          fontSize: 22,
          lineHeight: 32,
          textAlign: "center",
          maxWidth: 850,
          marginTop: 18,
        }}
      >
        {copy.attract.subtitle}
      </Text>

      <Pressable
        onPress={() => navigate("home", { replace: true })}
        accessibilityRole="button"
        style={({ pressed }) => ({
          marginTop: 34,
          minWidth: 260,
          minHeight: 66,
          paddingHorizontal: 28,
          borderRadius: 18,
          borderWidth: 1,
          borderColor: C.accent,
          backgroundColor: pressed ? C.surfaceRaised : C.accentSoft,
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <Text style={{ color: C.text, fontSize: 21, fontWeight: "900" }}>
          {copy.attract.start} →
        </Text>
      </Pressable>
    </View>
  );
}
